import router from "@/router/index.js";
import decodeTokenJWT from "@/services/office/tokens/decodeToken";

export function getSpecialAreasFromRoutes() {
  const specialAreas = new Set();
  router.getRoutes().forEach((route) => {
    if (route.meta && route.meta.isMunicipal && route.meta.requiredArea) {
      specialAreas.add(route.meta.requiredArea);
    }
  });
  return Array.from(specialAreas);
}

export function getMobileMuniRoutes(user, areas) {
  if (!user || user.role === "USER_ROLE") {
    return [];
  }

  return router.getRoutes().filter((r) => {
    // La ruta debe ser para municipal, permitir móvil y tener meta
    const isMunicipalMobile =
      r.meta && r.meta.isMunicipal && r.meta.allowMobile;
    if (!isMunicipalMobile) return false;

    // Los admins tienen acceso a todas las rutas móviles
    if (user.role === "ADMIN_ROLE") return true;

    // Para roles no-admin, validar el acceso por áreas
    const hasRequiredArea =
      r.meta.requiredArea ? 
      areas?.some(
        (userArea) => userArea?.area?.area_name === r.meta.requiredArea
      ) : true;
    const hasAllowedArea =
      r.meta.allowedAreas ?
      r.meta.allowedAreas.some((area) =>
        areas?.some((userArea) => userArea.area.area_name === area)
      ) : true;
      console.log("hasRequiredArea && hasAllowedArea ", hasRequiredArea && hasAllowedArea)
    return hasRequiredArea && hasAllowedArea;
  });
}

export function getAccessibleRoutes(user) {
  if (!user || !user.role) {
    return [];
  }

  const isUserMunicipal = user.role !== "USER_ROLE";
  const userAreas = user.areas?.map((area) => area.name) || [];
  const specialAreas = getSpecialAreasFromRoutes();
  const hasCommonArea = userAreas.some(
    (userArea) => !specialAreas.find((specialArea) => specialArea === userArea)
  );
  const isMobile = window.innerWidth <= 770;
  return router.getRoutes().filter((route) => {
    const routeMeta = route.meta;
    if(route.meta?.noValidate) return true;
    // **Validación 1: Rutas de Vecino para usuarios Vecino**
    // Si el usuario no es municipal y la ruta tampoco, deja pasar sin más validaciones.
    if (!isUserMunicipal && !routeMeta.isMunicipal) {
      return true;
    }
    // Si el usuario es municipal y la ruta NO es municipal, no tiene acceso.
    if (isUserMunicipal && !routeMeta.isMunicipal) {
      return false;
    }

    // Si la ruta es municipal, se aplican todas las siguientes validaciones

    // **Validación 2: Rutas que no permiten acceso en móvil**
    if (isMobile && !routeMeta.allowMobile) {
      return false;
    }

    // **Validación 3: Acceso del rol ADMIN**
    // Un ADMIN tiene acceso a todas las rutas municipales.
    if (user.role === "ADMIN_ROLE") {
      return true;
    }

    // **Validación 4: Rutas de Supervisor, Áreas Requeridas y Áreas Permitidas**
    // Lógica para roles no-admin
    if (isUserMunicipal) {
      // Condición para rutas de supervisor
      const supervisorAccess = routeMeta.isSupervisor
        ? user.role === "SUPERVISOR_ROLE"
        : true;
      if (!supervisorAccess) {
        return false;
      }

      // Condición para rutas que requieren un área específica
      if (routeMeta.requiredArea) {
        const hasRequiredArea = userAreas.includes(routeMeta.requiredArea);
        const userAreaWithLevel = user.areas.find(
          (userArea) => userArea.name === routeMeta.requiredArea
        );
        const hasMinLevel =
          !routeMeta.minLevel || userAreaWithLevel?.level >= routeMeta.minLevel;
        return hasRequiredArea && hasMinLevel;
      }

      // Condición para rutas generales con áreas permitidas
      const hasSpecialAreaAccess = routeMeta.allowedAreas?.some((area) =>
        userAreas.includes(area)
      );
      if (hasCommonArea || hasSpecialAreaAccess) {
        return true;
      }
    }

    // Por defecto, cualquier otra ruta municipal no es accesible
    return false;
  });
}

export function hasAccessToRoute(user, route) {
  const accessibleRoutes = getAccessibleRoutes(user);
  return accessibleRoutes.some(
    (accessibleRoute) => accessibleRoute.name === route.name
  );
}

export function navBarRoutes() {
  const token = localStorage.getItem("token");
  const user = decodeTokenJWT(token);
  if(!user) return [];
  const accessibleRoutes = getAccessibleRoutes(user);
  return (
    accessibleRoutes.filter((accessibleRoute) => accessibleRoute.meta?.home) ?? []
  );
}
